import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-elevation-1 transition-all duration-200"
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${stat?.bgColor}`}>
              <Icon name={stat?.icon} size={20} color={stat?.iconColor} strokeWidth={2.5} />
            </div>
            {stat?.trend && (
              <div className={`flex items-center gap-1 text-xs font-medium ${stat?.trendColor}`}>
                <Icon
                  name={stat?.trend === 'up' ? 'TrendingUp' : 'TrendingDown'}
                  size={14}
                  color="currentColor"
                />
                <span>{stat?.trendValue}</span>
              </div>
            )}
          </div>
          <p className="text-2xl font-bold text-foreground mb-1">{stat?.value}</p>
          <p className="text-sm text-muted-foreground">{stat?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default QuickStats;